<template>
  <div v-if="wave && wave.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('Waves', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/waves/' + wave.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Wave.title")]) }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          $permission.permissionAllow('Waves', 'receiveWave') && showReceive
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              currentItem = JSON.parse(JSON.stringify(wave));
              containerDialog = true;
            "
          >
            <v-icon x-small class="pe-1">fa-clipboard-list</v-icon>
            {{ $t("Wave.actions.receive") }}
          </v-btn>
        </template>
        <span>{{ $t("Wave.actions.receiveWave") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          $permission.permissionAllow('Waves', 'submitWavePicking') &&
          showStockPicking
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $router.push(
                '/waves/stock-picking/' + wave.id + '?stock_id=' + wave.stock_id
              )
            "
          >
            <v-icon x-small class="pe-1">fa-dolly-flatbed</v-icon>
            {{ $t("Wave.actions.stockPiking") }}
          </v-btn>
        </template>
        <span>
          {{ $t("Wave.actions.stockPiking") }}
        </span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          $permission.permissionAllow('Waves', 'submitSorting') &&
          showStockSorting
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="orange"
            class="px-2 me-2 mb-1"
            @click.stop="
              $router.push(
                '/waves/stock-order-binding/' +
                  wave.id +
                  '?stock_id=' +
                  wave.stock_id
              )
            "
          >
            <v-icon x-small class="pe-1">fa-grip-horizontal</v-icon>
            {{ $t("Wave.actions.stockSorting") }}
          </v-btn>
        </template>
        <span>
          {{ $t("Wave.actions.stockSorting") }}
        </span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          $permission.permissionAllow('Waves', 'forceCompleteSorting') &&
          showForceCompleteSorting
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="$emit('forceComplete', wave.id)"
          >
            <v-icon x-small class="pe-1">fa-check-double</v-icon>
            {{ $t("Wave.actions.forceCompleteSorting") }}
          </v-btn>
        </template>

        <span>
          {{ $t("Wave.actions.forceCompleteSorting") }}
        </span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          $permission.permissionAllow('Waves', 'waveRelease') && showRelease
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="$emit('release', wave.id)"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("Wave.actions.release") }}
          </v-btn>
        </template>
        <span>{{ $t("Wave.actions.releaseWave") }}</span>
      </v-tooltip>
      <v-menu
        v-model="printBtnMenu"
        open-on-hover
        close-on-click
        close-on-content-click
        offset-y
        v-if="
          $permission.permissionAllow('Waves', 'pickingPrint') ||
          $permission.permissionAllow('Waves', 'stockOutsPrint') ||
          $permission.permissionAllow('Waves', 'getPickAndSortingList') ||
          $permission.permissionAllow('Waves', 'facePrint') ||
          $permission.permissionAllow('Waves', 'distributionsPrint') ||
          $permission.permissionAllow('Waves', 'shopDistributionsPrint')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-print</v-icon>
            {{ $t("Print.print") }}
            <v-icon x-small class="ps-1">
              {{ printBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <!-- 拣货打印 -->
          <v-list-item
            v-if="$permission.permissionAllow('Waves', 'pickingPrint')"
            @click.stop="doPrint('stockPickingPrint')"
          >
            <v-list-item-title>
              {{ $t("Wave.actions.stockPickingPrint") }}
            </v-list-item-title>
          </v-list-item>
          <!-- 发货明细打印 -->
          <v-list-item
            v-if="$permission.permissionAllow('Waves', 'stockOutsPrint')"
            @click.stop="doPrint('deliveryDetailPrint')"
          >
            <v-list-item-title>
              {{ $t("Wave.actions.deliveryDetailPrint") }}
            </v-list-item-title>
          </v-list-item>
          <!-- 分拣打印 -->
          <v-list-item
            v-if="
              wave.status == 2 &&
              $permission.permissionAllow('Waves', 'getPickAndSortingList')
            "
            @click.stop="doPrint('stockSortingPrint')"
          >
            <v-list-item-title>
              {{ $t("Wave.actions.stockSortingPrint") }}
            </v-list-item-title>
          </v-list-item>
          <!-- 面单打印 -->
          <v-list-item
            v-if="$permission.permissionAllow('Waves', 'facePrint')"
            @click.stop="doPrint('expressSheetPrint')"
          >
            <v-list-item-title>
              {{ $t("Wave.actions.expressSheetPrint") }}
            </v-list-item-title>
          </v-list-item>
          <v-divider v-if="wave.type == 1" />
          <!-- 预打印配送单 -->
          <v-list-item
            v-if="
              wave.type == 1 &&
              $permission.permissionAllow('Waves', 'distributionsPrint')
            "
            @click.stop="doPrint('distributionPrint')"
          >
            <v-list-item-title>
              {{ $t("Wave.actions.distributionPrint") }}
              <span v-if="wave.distribution_print_count">
                {{ $t("Global.brackets", [wave.distribution_print_count]) }}
              </span>
            </v-list-item-title>
          </v-list-item>
          <!-- 门店配送打印 -->
          <v-list-item
            v-if="
              $permission.permissionAllow('Waves', 'shopDistributionsPrint')
            "
            @click.stop="doPrint('shopDistributionPrint')"
          >
            <v-list-item-title>
              {{
                $t("Wave.actions.shopDistributionPrint", [$consts.shopName()])
              }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- TODO:缺接口 -->
      <v-menu
        v-model="exportBtnMenu"
        open-on-hover
        close-on-click
        close-on-content-click
        offset-y
        v-if="false && $permission.permissionAllow('Waves', 'sortingExport')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("Export.export", [""]) }}
            <v-icon x-small class="ps-1">
              {{ exportBtnMenu ? "fa-caret-up" : "fa-caret-down" }}
            </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-if="$permission.permissionAllow('Waves', 'sortingExport')"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                // TODO
              })
            "
          >
            <v-list-item-title>
              {{ $t("Wave.actions.preSortingExport") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-sheet>
    <ContainerDialog
      v-model="containerDialog"
      :wave="wave"
      @save="$emit('save', wave)"
      @confirm="containerDialog = false"
    />
  </div>
</template>

<script>
import ContainerDialog from "@/components/stockContainers/plugins/Dialog";

export default {
  name: "WaveActions",

  props: {
    wave: Object,
    detailMode: Boolean,
    showView: Boolean,
    showReceive: Boolean,
    showRelease: Boolean,
    showStockPicking: Boolean,
    showStockSorting: Boolean,
    showForceCompleteSorting: Boolean,
  },

  components: {
    ContainerDialog,
  },

  data: () => ({
    printBtnMenu: false,
    exportBtnMenu: false,
    containerDialog: false,
  }),

  methods: {
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          switch (mode) {
            case "stockSortingPrint":
              this.$router.push("/print/stock-sorting/" + this.wave.id);
              break;
            case "stockPickingPrint":
              this.$router.push(
                "/print/wave-stockPicking-print/" + this.wave.id
              );
              break;
            case "distributionPrint":
              this.$router.push(
                "/print/wave-distributions-print/" + this.wave.id
              );
              break;
            case "shopDistributionPrint":
              this.$router.push(
                "/print/wave-shop-distributions-print/" + this.wave.id
              );
              break;
          }
        }.bind(this)
      );
    },
  },
};
</script>